import React, { useState } from 'react';
import './App.css';
import vikingsLogo from './logo-vikings.png';

const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwPkeHLTONWK8zQSaSNhUQEmbcoNM6saAZ4w2PTqbVlYBkqwktY-oEiQB7r-Vj_hG6ShQ/exec';

const reasons = [
  'I no longer use this service',
  'I have privacy concerns',
  'I created a duplicate account',
  'The service did not meet my expectations',
  'I am switching to another platform',
  'Other',
];

const INIT = {
  fullName: '',
  username: '',
  age: '',
  gender: '',
  email: '',
  phone: '',
  reason: '',
  details: '',
  confirmUnderstand: false,
  confirmDelete: false,
};

function Field({ label, hint, children }) {
  return (
    <div className="field">
      <label className="field-label">{label}</label>
      {hint && <div className="field-hint">{hint}</div>}
      {children}
    </div>
  );
}

function App() {
  const [data, setData]           = useState(INIT);
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending]     = useState(false);
  const [sendError, setSendError] = useState('');

  const update = (key) => (e) => setData((prev) => ({ ...prev, [key]: e.target.value }));
  const toggle = (key) => () => setData((prev) => ({ ...prev, [key]: !prev[key] }));

  const handleSubmit = async () => {
    setSending(true);
    setSendError('');

    const payload = {
      'Full Name':             data.fullName  || '—',
      'Username':              data.username  || '—',
      'Age':                   data.age       || '—',
      'Gender':                data.gender    || '—',
      'Email':                 data.email     || '—',
      'Phone':                 data.phone     || '—',
      'Reason':                data.reason    || '—',
      'Details':               data.details   || '—',
      'Confirmed Understand':  data.confirmUnderstand ? 'Yes' : 'No',
      'Confirmed Delete':      data.confirmDelete     ? 'Yes' : 'No',
      'Submitted At':          new Date().toLocaleString('en-PH', { timeZone: 'Asia/Manila' }),
    };

    try {
      const res = await fetch(SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      // Google Apps Script with no-cors always returns opaque response
      // so we just assume success if no network error was thrown
      setSubmitted(true);
    } catch (err) {
      console.error('Formspree error:', err);
      setSendError('Network error. Please check your connection and try again.');
    } finally {
      setSending(false);
    }
  };

  if (submitted) {
    return (
      <div className="page">
        <div className="card">
          <div className="success-wrap">
            <div className="success-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1d1515" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <h2 className="success-title">Request submitted</h2>
            <p className="success-desc">
              Your account deletion request has been received and sent to the admin.<br />
              We will process it within <strong>7 business days</strong>.
              {data.email && (
                <> A confirmation will be sent to <strong>{data.email}</strong>.</>
              )}
            </p>
            <button
              className="btn btn-cancel"
              style={{ marginTop: 24, width: 'auto', padding: '10px 28px' }}
              onClick={() => { setData(INIT); setSubmitted(false); setSendError(''); }}
            >
              Submit another request
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <div className="card">

        {/* Header */}
        <div className="card-header">
          <div className="header-logo-wrap">
            <img src={vikingsLogo} alt="Vikings Global" className="header-logo" />
          </div>
          <div className="header-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f10505" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14H6L5 6" />
              <path d="M10 11v6M14 11v6" />
              <path d="M9 6V4h6v2" />
            </svg>
          </div>
          <h1 className="header-title">Delete account request</h1>
          <p className="header-sub">Fill in your details below to permanently delete your account. This action cannot be undone.</p>
        </div>

        {/* Body */}
        <div className="card-body">

          {/* Warning */}
          <div className="warning-box">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#b91c1c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 1 }}>
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <p>
              Deleting your account will permanently remove all your data, history, and access.
              This <strong>cannot be reversed</strong> once processed.
            </p>
          </div>

          {/* Row: Full Name + Username */}
          <div className="row-2">
            <Field label="Full name">
              <input type="text" value={data.fullName} onChange={update('fullName')} placeholder="e.g. Juan dela Cruz" />
            </Field>
            <Field label="Username">
              <input type="text" value={data.username} onChange={update('username')} placeholder="e.g. juandelacruz" />
            </Field>
          </div>

          {/* Row: Age + Gender */}
          {/* <div className="row-2">
            <Field label="Age">
              <input type="number" value={data.age} onChange={update('age')} placeholder="e.g. 25" min="1" />
            </Field>
            <Field label="Gender">
              <select value={data.gender} onChange={update('gender')}>
                <option value="">Select gender</option>
                <option>Male</option>
                <option>Female</option>
                <option>Non-binary</option>
                <option>Prefer not to say</option>
              </select>
            </Field>
          </div> */}

          {/* Email */}
          <Field label="Email address">
            <input type="email" value={data.email} onChange={update('email')} placeholder="you@example.com" />
          </Field>

          {/* Phone */}
          <Field label="Phone number">
            <input type="text" value={data.phone} onChange={update('phone')} placeholder="+63 917 000 0000" />
          </Field>

          <hr className="divider" />

          {/* Reason */}
          <Field label="Reason for deletion">
            <select value={data.reason} onChange={update('reason')}>
              <option value="">Select a reason</option>
              {reasons.map((r) => (
                <option key={r} value={r}>{r}</option>
              ))}
            </select>
          </Field>

          {/* Details */}
          <Field label="Additional details" hint="Tell us more about your reason (optional)">
            <textarea value={data.details} onChange={update('details')} placeholder="Any additional context you'd like to share..." />
          </Field>

          <hr className="divider" />

          {/* Checkboxes */}
          <div className={`check-item ${data.confirmUnderstand ? 'on' : ''}`} onClick={toggle('confirmUnderstand')}>
            <input type="checkbox" checked={data.confirmUnderstand} readOnly />
            <span>I understand that deleting my account is <strong>permanent and irreversible</strong>, and all my data will be lost.</span>
          </div>

          <div className={`check-item ${data.confirmDelete ? 'on' : ''}`} onClick={toggle('confirmDelete')}>
            <input type="checkbox" checked={data.confirmDelete} readOnly />
            <span>I confirm that I want to <strong>permanently delete</strong> my account and all associated data.</span>
          </div>

          {/* Send error */}
          {sendError && (
            <div className="send-error">{sendError}</div>
          )}

          {/* Buttons */}
          <div className="btn-row">
            <button className="btn btn-cancel" onClick={() => { setData(INIT); setSendError(''); }} disabled={sending}>
              Cancel
            </button>
            <button className="btn btn-delete" onClick={handleSubmit} disabled={sending}>
              {sending ? 'Sending...' : 'Submit deletion request'}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}

export default App;